module.exports = {
    metric: {
        'metric-tons-of-cfc-11-equivalent': {
            name: {
                singular: 'CFC-11', 
                plural: 'CFC-11'
            }
            , to_anchor: 1
        }
    }, 
    imperial: {}, 
    _anchors: {
        metric: {
            unit: 'metric-tons-of-cfc-11-equivalent'
            , ratio: .000001
        }
    }
};
